module.exports = __webpack_public_path__ + "img/fuka.78474e00.png";